import { defineStore } from "pinia";
import { Times } from "src/utils/constants";
import { ToastState } from "./types";

export const useToastStore = defineStore("toast", {
  state: (): ToastState => ({
    visible: false,
    message: undefined,
    timerHandle: undefined
  }),
  actions: {
    async showToast(payload: string | { message: string; duration: number }) {
      let message: string;
      let duration: number | undefined;
      if (typeof payload === "string") {
        message = payload;
      } else {
        message = payload.message;
        duration = payload.duration;
      }

      this.message = message;
      this.visible = true;

      // If the duration is set to something less than 0 don't set a timer
      if (duration && duration <= 0) {
        // Still want to clear the timer though
        clearTimeout(this.timerHandle);
        this.timerHandle = undefined;
        return;
      }

      // Set a timer to hide the toast, using the default time if nothing is defined
      clearTimeout(this.timerHandle);
      this.timerHandle = setTimeout(
        () => this.hideToast(message),
        duration ?? Times.DefaultToastDurationMs
      );
    },
    hideToast(message?: string) {
      // Basic sanity checks to we can tell if something is going wrong
      if (!this.visible) {
        console.warn(
          `Attempted to hide toast even when already hidden. Message passed: ${message}`
        );
      }

      if (message && this.message !== message) {
        console.warn(
          `Attempted to hide toast with a different message than stored in the state. Message passed: ${message} Store message: ${this.message}`
        );
      }

      // No matter what clear the timer and hide the toast
      clearTimeout(this.timerHandle);
      this.timerHandle = undefined;
      this.visible = false;
    }
  }
});
